import type { GamePlatformMetadata } from './game-platform-metadata.interface';

export const LIBRARY_CUSTOM_GAME_PLATFORM_VALUE = 'CUSTOM';

export const LIBRARY_GAME_PLATFORM_OPTIONS = [
  {
    value: 'PC',
    label: 'PC',
    isCustom: false,
  },
  {
    value: 'PLAYSTATION_5',
    label: 'PlayStation 5',
    isCustom: false,
  },
  {
    value: 'PLAYSTATION_4',
    label: 'PlayStation 4',
    isCustom: false,
  },
  {
    value: 'XBOX_SERIES',
    label: 'Xbox Series X/S',
    isCustom: false,
  },
  {
    value: 'XBOX_ONE',
    label: 'Xbox One',
    isCustom: false,
  },
  {
    value: 'NINTENDO_SWITCH',
    label: 'Nintendo Switch',
    isCustom: false,
  },
  {
    value: 'STEAM_DECK',
    label: 'Steam Deck',
    isCustom: false,
  },
  {
    value: LIBRARY_CUSTOM_GAME_PLATFORM_VALUE,
    label: 'Inna platforma',
    isCustom: true,
  },
] as const satisfies readonly GamePlatformMetadata[];
